module.exports = __webpack_public_path__ + "img/textColor.c3527114.svg";